import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ToastComponent } from './toast.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SvgIconModule
    ],
    declarations: [
        ToastComponent
    ],
    exports: [
        ToastComponent
    ]
})

export class ToastModule {}
